<template>
  <div class="row_center_between add_to_cart_section">
    <div class="row_center_start w-full flex-grow" v-if="isQuantityLocked">
      <text class="locked_quantity">兌換數量 <b>{{ quantity }}</b></text>
    </div>
    <div class="row_center_start w-full flex-grow" v-else>
      <div class="row_center_center" style="background-color: #DDDDDD; border-radius: 50%; padding: 2px;"
        @click="subtractQuantity">
        <text id="remove" class="button-icon"
          style="color: #000; font-size: 32px; height: 32px; width: 32px">remove</text>
      </div>
      <input type="number" min="1" step="1" class="row_center_center item_count" v-model="quantity1" />
      <div class="row_center_center" style="background-color: #FBCB02; border-radius: 50%; padding: 2px;"
        @click="addQuantity">
        <text id="add" class="button-icon" style="color: #000; font-size: 32px; height: 32px; width: 32px">add</text>
      </div>
    </div>
    <button class="button" style="width: 170px" @click="addToCart">{{ buttonText }}</button>
  </div>
</template>
<script>
import commonUtils from '@/utils/common.utils';
export default {
  props: {
    quantity: {
      type: Number,
      default: 1,
      required: true,
    },
    // 兌換模式：數量固定不可調整
    isQuantityLocked: {
      type: Boolean,
      default: false,
    },
    buttonText: {
      type: String,
      default: "加入購物車",
    },
  },
  data() {
    return {
      quantity1: this.quantity,
    };
  },
  mounted() {
    this.quantity1 = this.quantity;
  },
  watch: {
    quantity1(newVal) {
      if (newVal < 1) {
        return;
      }
      this.quantity1 = Math.round(Math.abs(this.quantity1))
      this.$emit("updateQuantity", newVal);
    },
  },
  methods: {
    subtractQuantity() {
      if (this.quantity1 === 1) return
      this.quantity1 -= 1
    },
    addQuantity() {
      this.quantity1 += 1
    },
    addToCart() {
      const reg = /^[1-9]\d*$/
      if (this.quantity1 < 1 || !reg.test(this.quantity1)) {
        commonUtils.createToast('error', '請輸入正確數量')
        return
      }
      this.$emit("addToCart")
    },
  },
};
</script>
<style lang="scss">
.add_to_cart_section {
  width: 100%;
  height: 65px;
  padding: 5px 2% 10px 5%;
  background-color: #fff;
  color: #000;
  font-size: 18px;
  font-weight: 500;
  font-family: PingFang SC;
  z-index: 999;
  flex-shrink: 0;
}

.buttonImg {
  width: 54px;
  height: 54px;
}

.locked_quantity {
  font-size: 16px;
  color: #333;

  b {
    font-size: 18px;
  }
}

.item_count {
  height: 46px;
  width: 65px;
  border: 1px solid #DDDDDD;
  border-radius: 8px;
  margin: 0 5px;
  text-align: center;
}
</style>
